<script>
  import Icon from "@iconify/svelte";

  let { onclick, variant = "primary", size = "md", disabled = false, loading = false, type = "button", class: className = "", children } = $props();

  const baseClasses = "inline-flex items-center justify-center gap-2 rounded border font-semibold transition-colors select-none";

  const variantClasses = {
    primary: "ui-btn-accent border-lime-600 bg-lime-600 text-white hover:bg-lime-500 hover:text-white",
    secondary: "ui-btn-accent-secondary border-sky-300/70 text-sky-300 hover:bg-sky-300/20 hover:text-white",
    danger: "border-rose-600 bg-rose-600 text-white hover:bg-rose-500 hover:text-white",
    ghost: "border-transparent bg-transparent text-zinc-400 hover:text-white hover:bg-white/[0.06]",
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base",
  };
</script>

<button
  {type}
  disabled={disabled || loading}
  onclick={onclick}
  class="{baseClasses} {variantClasses[variant] || variantClasses.primary} {sizes[size] || sizes.md} disabled:opacity-50 disabled:cursor-not-allowed {className}"
>
  {#if loading}
    <Icon icon="mdi:loading" class="animate-spin -ml-1 mr-2 h-4 w-4" />
  {/if}
  {@render children()}
</button>
